import I18n from 'I18n';
import { DISTRIBUTIONS } from 'routing-ui/routing-rules/constants/distributions';
import { getDistribution, getUsersAndTeams } from 'routing-ui/routing-rules/operators/routingRulesGetters';
import count from 'transmute/count';
const getMixedUsersAndTeamsType = (userCount, teamCount) => {
  if (teamCount > 1 && userCount > 1) {
    return 'multiple-both';
  }
  if (userCount > 1) {
    return 'single-team';
  }
  if (teamCount > 1) {
    return 'single-user';
  }
  return 'single-both';
};
const getUsersAndTeamsType = (userCount, teamCount) => {
  if (teamCount > 0 && userCount > 0) {
    return getMixedUsersAndTeamsType(userCount, teamCount);
  }
  if (userCount > 0) {
    return 'users-only';
  }
  if (teamCount > 0) {
    return 'teams-only';
  }
  return '';
};
export const getDistributionText = routingRuleDefinition => {
  const distribution = getDistribution(routingRuleDefinition);
  switch (distribution) {
    case DISTRIBUTIONS.BALANCED:
    case DISTRIBUTIONS.LEAST_BUSY:
      return I18n.text('automation-ui-action-features.action-features.rotate-object.unified-routing.distribution.balanced');
    case DISTRIBUTIONS.RANDOM:
      return I18n.text('automation-ui-action-features.action-features.rotate-object.unified-routing.distribution.random');
    default:
      return '';
  }
};
export const getActionMessageInfo = routingRuleDefinition => {
  const {
    teamIds,
    userIds
  } = getUsersAndTeams(routingRuleDefinition);
  const teamCount = count(teamIds);
  const userCount = count(userIds);
  const type = getUsersAndTeamsType(userCount, teamCount);
  return {
    distribution: getDistributionText(routingRuleDefinition),
    teamCount,
    type,
    userCount
  };
};